module.exports = __webpack_public_path__ + "img/chain_sale01.f58cf07b.png";